export function toComparablePrice(value) {
  if (value === null || value === undefined || value === "") return null

  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null
  }

  if (typeof value === "string") {
    const normalized = value.trim().replace(",", ".")
    if (!normalized) return null

    const parsed = Number(normalized)
    return Number.isFinite(parsed) ? parsed : null
  }

  return null
}

export function matchesPriceBounds({ price, minPrice, maxPrice }) {
  const normalizedPrice = toComparablePrice(price)
  if (normalizedPrice === null) return false

  const min = toComparablePrice(minPrice)
  const max = toComparablePrice(maxPrice)

  if (min !== null && normalizedPrice < min) return false
  if (max !== null && normalizedPrice > max) return false

  return true
}
